// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// #region  Rectangle
export class Rectangle {
    constructor(newX, newY, newWidth, newHeight) {
        this.X = newX || 0;
        this.Y = newY || 0;
        this.Width = newWidth || 0;
        this.Height = newHeight || 0;
    }
    Right() {
        return this.X + this.Width;
    }
    Left() {
        return this.X;
    }
    Bottom() {
        return this.Y + this.Height;
    }
    Top() {
        return this.Y;
    }
    IsEmpty() {
        return this.X === 0 && this.Y === 0 && this.Width === 0 && this.Height === 0;
    }
    Empty() {
        this.X = 0;
        this.Y = 0;
        this.Width = 0;
        this.Height = 0;
    }
    Inflate(width, height) {
        this.Width += width;
        this.Height += height;
    }
    get Location() {
        return new Point(this.X, this.Y);
    }
    set Location(value) {
        this.X = value.X;
        this.Y = value.Y;
    }
    static Empty() {
        const res = new Rectangle();
        res.Empty();
        return res;
    }
    Contains(testX, testY) {
        if (this.IsEmpty()) {
            return false;
        }
        return this.X <= testX && testX < this.X + this.Width && this.Y <= testY && testY < this.Y + this.Height;
    }
    ContainsRectangle(rect) {
        if (this.IsEmpty() || !rect || rect.IsEmpty()) {
            return false;
        }
        return this.Contains(rect.Left(), rect.Top()) && this.Contains(rect.Right(), rect.Bottom());
    }
    // TODO. Rename.
    CanFit(w, h) {
        if (this.IsEmpty()) {
            return;
        }
        return this.Width >= w && this.Height >= h;
    }
    Equals(rect) {
        return (this === rect ||
            (this.X === rect.X && this.Y === rect.Y && this.Width === rect.Width && this.Height === rect.Height));
    }
    toString() {
        return ('{ ' +
            'X:' +
            this.X +
            ' ' +
            'Y:' +
            this.Y +
            ' ' +
            'Width:' +
            this.Width +
            ' ' +
            'Height:' +
            this.Height +
            ' }');
    }
    copy() {
        return new Rectangle(this.X, this.Y, this.Width, this.Height);
    }
    intersect(rect) {
        const x1 = Math.max(this.X, rect.X);
        const y1 = Math.max(this.Y, rect.Y);
        const x2 = Math.min(this.X + this.Width, rect.X + rect.Width);
        const y2 = Math.min(this.Y + this.Height, rect.Y + rect.Height);
        if (x2 <= x1 || y2 <= y1) {
            return null;
        }
        return new Rectangle(x1, y1, x2 - x1, y2 - y1);
    }
}
// #endregion  Rectangle
// #region  Point
export class Point {
    constructor(x, y) {
        this.X = x || 0;
        this.Y = y || 0;
    }
    IsEmpty() {
        return this.X === 0 && this.Y === 0;
    }
    Empty() {
        this.X = 0;
        this.Y = 0;
    }
    Equals(p) {
        return this.X === p.X && this.Y === p.Y;
    }
    // static
    static Empty() {
        const res = new Point();
        res.X = 0;
        res.Y = 0;
        return res;
    }
}
// #endregion
// -----------------
// #region Size
export class Size {
    constructor(width, height) {
        this.Width = width || 0;
        this.Height = height || 0;
    }
}
// #endregion
